module.exports = __webpack_public_path__ + "static/img/classposter1.f0cddcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/classposter1.jpg
// module id = LI29
// module chunks = 49